import { type ReactElement } from "react";

export const Stop = (): ReactElement => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5.25" y="5.25" width="13.5" height="13.5" />
    </svg>
  );
};
